import React from 'react';
import styled from 'styled-components';
import { mapping } from './assets';

export interface HomeHeaderProps {
  score: number;
  speed: number;
  distance: number;
}

const StyledHomeHeader = styled.header`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  font-size: ${({ theme }) => theme.fontSize.header}px;
  background: linear-gradient(#000000 -4.63%, rgba(0, 0, 0, 0) 91.2%);
  box-sizing: border-box;
  padding: 60px 60px 0;
  z-index: 999;
`;

const Total = styled.div`
  display: flex;
  column-gap: 50px;
  margin-left: auto;
`;

const Score = styled.div`
  position: relative;
  padding-left: 70px;
`;

const Money = styled.img`
  position: absolute;
  left: -100px;
  top: -45px;
`;

export const HomeHeader: React.FC<HomeHeaderProps> = ({ score, distance, speed }) => (
  <StyledHomeHeader>
    <div>Sber</div>
    <Total>
      <div>Total record:</div>
      <div>Speed x{speed}</div>
      <Score>
        <Money src={mapping.money['1x']} srcSet={`${mapping.money['2x']} 2x`} />
        {String(score).padStart(3, '0')}
      </Score>
      <div>
        {String(distance).padStart(4, '0')} m
      </div>
    </Total>
  </StyledHomeHeader>
);
